module.exports = {
	"close.mediaBrowser": "Close Media Browser",
	"choose": "Choose",
	"item": "item",
	"mediaItem": "media item",
	"pluralItem": "a media item",
	"rename.item": "Rename Item{item}",
	"media": "Media",
	"name": "Name",
	"dimensions": "Dimensions",
	"fileSize": "File Size",
	"editedOn": "Edited On",
	"search.tryAnother": "Try another search",
	"contents.fetchingContents": "Hold tight while we fetch {cd}",
	"search.noResults": "Uh oh. No results found for \"{filter}\"",
	"grammar.or": "or",
	"search.clearFilter": "clear the search filter",
	"directory.appearsToBeEmpty": "Directory \"{cd}\" appears to be empty.",
	"perhapsYouWouldLikeTo": "Perhaps you'd like to",
	"upload.someFiles": "upload some files",
	"grammar.to": "to",
	"directory.set": "Set Directory",
	"directory.browse": "Browse Directory",
	"support.noVideo": "Your browser does not support HTML5 Video.",
	"support.noAudio": "Your browser does not support HTML5 Audio.",
	"select": "Select",
	"grammar.a": "a",
	"media.source": "Media Source",
	"modal.closeWindow": "Close {title} Modal Window",
	"cancel": "Cancel",
	"directory.cancelCreating": "creating directory {cd}",
	"create": "Create",
	"directory": "directory",
	"cropAs": "Crop as",
	"crop": "Crop",
	"saveAs": "Save As",
	"showAdvControls": "Show Advanced Controls",
	"dragMode": "Drag Mode",
	"crop.move": "Move",
	"crop.showGuides": "Show Guides",
	"crop.zoomIn": "Zoom In",
	"crop.zoomOut": "Zoom Out",
	"crop.moveLeft": "Move Left",
	"crop.moveRight": "Move Right",
	"crop.moveUp": "Move Up",
	"crop.moveDown": "Move Down",
	"crop.download": "Download Cropped Image",
	"crop.uploadImage": "Upload Image",
	"crop.boundingBox": "Bounding Box (px)",
	"crop.X": "X",
	"crop.Y": "Y",
	"crop.width": "Width",
	"crop.height": "Height",
	"crop.aspectRatio": "Aspect Ratio",
	"crop.free": "Free",
	"rememberAspectRatio": "Remember Ratio",
	"crop.scaleRotate": "Scale & Rotate",
	"crop.rotate": "Rotate",
	"crop.scale": "Scale",
	"reset": "Reset",
	"renamingItem": "renaming item {filename}",
	"welcome.learnMore": "Learn more",
	"filter": "Filter",
	"sortBy": "Sort by",
	"upload.files": "Upload files",
	"upload.dragFilesUploading": "Uploading files…",
	"layout.masonry": "Masonry Layout",
	"layout.fullscreenMode": "Fullscreen Mode",
	"layout.viewMode": "View Mode",
	"layout.table": "Table Layout",
	"layout.thumb": "Thumbnail Layout",
	"layout.grid": "Grid Layout",
	"layout.list": "List Layout",
	"media.browse": "Browse",
	"media.contents": "Media Content",
	"directory.create": "Create a Directory",
	"directory.createNewIn": "Create a new Directory in {cd}",
	"cropItem": "Crop {item}",
	"cropAsItem": "Crop as {item}",
	"saveAsItem": "Save as {item}",
	"croppingItem": "Cropping {item}",
	"mediaSourceTree": "Media Source Panel",
	"pastImageFromClipboardMessage": "Paste images from the clipboard to upload",
	"pastImageFromClipboardToMessage": "Paste images from the clipboard to upload to ${cd} of source ${cs}",
	"deleteAreYouSureMessage": "Are you sure you want to permanently delete {filename}?",
	"cropAreYouSureMessage": "Are you sure you want to reset your crop?",
	"masonryLayoutMessage": "Masonry Layout",
	"close": "Close",
	"open": "Open",
	"rename": "Rename",
	"welcomeToEureka": "Welcome to Eureka. You found it.",
	"delete": "Delete",
	"in": "in",
	"file.create": "Create File",
	"contents.ofby": "contents of {cd} by filename, filesize, dimensions or even modification date",
	"contents.filterBy": "Filter contents of {cd} by filename, filesize, dimensions or even modification date",
	"file.quickCreate": "Quick Create Files",
	"rename.cannot": "Cannot rename {filename} to the same name",
	"expand": "Expand",
	"choose.item": "Choose {filename}",
	"new.name": "New name",
	"directory.delete": "Delete Directory",
	"delete.item": "Delete {filename}",
	"deleted.item": "Deleted {filename}",
	"download": "Download",
	"download.item": "Download {filename}",
	"expand.item": "Expand {filename}",
	"directory.refresh": "Refresh Directory",
	"upload.filesTo": "Upload File to {cd}",
	"upload.createFileIn": "Create File in {cd}",
	"context.performActions": "Perform Actions such as Expand or Choose on {filename}",
	"layout.tabular": "Tabular Layout displays image thumbnails along with Name, Description, File Size and Edited On columns",
	"layout.thumbnail": "Thumbnail layout displays a grid of medium sized thumbnails",
	"file.openInNewTab": "Open {filename} in a new tab",
	"toggle": "Toggle",
	"pluralChoose": "item",
	"copyListofSelectedFiles": "Copy list of selected files",
	"media.sourceTree": "Media Source Panel",
	"upload.dragFilestoUpload": "Drag files here to be uploaded to {cd}",
	"crop.hideGuides": "Hide Guides",
	"crop.toggleGuides": "Toggle Guides",
	"crop.cropZoomOut": "Zoom Out",
	"crop.upload": "Upload"
};


//////////////////
// WEBPACK FOOTER
// ./i18n/locales/en.json
// module id = 758
// module chunks = 0